import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, dashboardFeatureKey } from './dashboard.reducer';

export const dashboardFeature = createFeatureSelector<State>(dashboardFeatureKey);

export const getCallState = createSelector(dashboardFeature, (state) => {
   return state.callState;
});

export const getDashboards = createSelector(dashboardFeature, (state) => {
   return state.dashboards;
});

export const getSelectedDashboard = createSelector(dashboardFeature, (state) => {
   return state.selectedDashboard;
});

export const getCustomTiles = createSelector(getSelectedDashboard, (selectedDashboard) => {
   return selectedDashboard?.dashboardTiles.filter((dt) => dt.tile.isCustom);
});

export const getFullscreenTile = createSelector(dashboardFeature, (state) => {
   return state.fullscreenTile;
});

export const getPreviewTile = createSelector(dashboardFeature, (state) => {
   return state.previewTile;
});

export const getPreservedLayoutFromDashboard = createSelector(dashboardFeature, (state) => {
   return state.preservedLayout;
});

export const getCurrentDashboardColumnLayoutSize = createSelector(dashboardFeature, (state) => {
   return state.currentDashboardColumnLayoutSize;
});

export const getDisplayLayout = createSelector(dashboardFeature, (state) => {
   return state.displayLayout;
});
